import React, { useCallback, useEffect, useState } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { createPortal } from 'react-dom';
import { Modal } from '@/components/common/Modal';

type ModalRenderer = (onClose: () => void) => React.ReactNode;

export const useModal = (render: ModalRenderer) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const show = useCallback(() => {
    onOpen();
  }, [onOpen]);

  const hide = useCallback(() => {
    onClose();
  }, [onClose]);

  const modalElement =
    isOpen && mounted
      ? createPortal(
          <Modal isOpen={isOpen} onClose={onClose} isCentered blockScrollOnMount={false}>
            <Modal.Overlay />
            <Modal.Content maxW="unset" sx={{ width: 'fit-content' }}>
              {render(onClose)}
            </Modal.Content>
          </Modal>,
          document.body,
        )
      : null;

  return { show, hide, modal: modalElement };
};
